<template>
  <transition
    name="fade"
    mode="out-in"
    :duration="{ enter: 1000, leave: 200 }"
  >
    <BaseLoading v-if="isMatchEventsLoading" />
    <div v-else>
      <template v-if="events.length">
        <b-row>
          <b-col
            v-for="event in events"
            :key="event.id"
            :cols="12"
          >
            <TheMatchGifHighlight
              :poster="event.image_url"
              :webm-url="event.video_webm_url"
              :mp4-url="event.video_mp4_url"
              :team1-image="event.match.team1.image_url"
              :team1-name="event.match.team1.display_name[$i18n.locale]"
              :team2-image="event.match.team2.image_url"
              :team2-name="event.match.team2.display_name[$i18n.locale]"
              :is-performance="!! event.performance"
              :athlete-name="event.performance ? event.performance.athlete.name[$i18n.locale] : null"
              :performance-category-name="event.performance ? event.performance.category.name : null"
              :time="event.time"
              @play="handleVideoPlay"
            />
          </b-col>
        </b-row>
      </template>
      <BaseAlert
        v-else
        variant="light"
        is-center
      >
        {{ $t('nobody-has-scored-in-this-match-yet') }}
      </BaseAlert>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BaseLoading from '@/components/Atoms/BaseLoading'
import TheMatchGifHighlight from '@/components/Molecules/TheMatchGifHighlight'
import BaseAlert from '@/components/Atoms/BaseAlert'
export default {
  name: 'MatchPublicHighlights',
  components: { BaseAlert, TheMatchGifHighlight, BaseLoading },
  data() {
    return {
      matchId: `${this.$route.params.league}/${this.$route.params.match}`,
    }
  },
  computed: {
    ...mapState({
      isMatchEventsLoading: state => state['matches/matchEvents'].isMatchEventsLoading,
    }),
    events() {
      return this.$store.getters['matches/matchEvents/getMatchEvents'](this.matchId)
    },
  },
  created() {
    this.fetchMatchEvents({
      matchId: this.matchId,
    })
  },
  methods: {
    ...mapActions({
      fetchMatchEvents: 'matches/matchEvents/fetchMatchEvents',
      incrementPlayedCount: 'matches/matchGifs/incrementPlayedCount',
    }),
    handleVideoPlay() {
      this.incrementPlayedCount()
    },
  },
}
</script>

<style scoped>

</style>
